import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BasicLayoutComponent } from '../../components/common/layouts/basicLayout.component';
import { UsuarioAutenticadoGuard } from '../../core/guards/usuario-autenticado.guard';
import { Dashboard1Component } from './dashboard1.component';
import { Dashboard2Component } from './dashboard2.component';
import { Dashboard3Component } from './dashboard3.component';
import { Dashboard4Component } from './dashboard4.component';
import { Dashboard41Component } from './dashboard41.component';
import { Dashboard5Component } from './dashboard5.component';


const routes: Routes = [
  {
    path: 'dashboard1',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: Dashboard1Component,
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'dashboard2',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: Dashboard2Component,
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'dashboard3',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: Dashboard3Component,
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'dashboard4',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: Dashboard4Component,
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'dashboard41',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: Dashboard41Component,
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  },
  {
    path: 'dashboard5',
    component: BasicLayoutComponent,
    children: [
      {
        path: '', component: Dashboard5Component,
      }
    ],
    canActivate: [UsuarioAutenticadoGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardsRoutingModule { }
